module.exports = __webpack_public_path__ + "static/media/2levelHigh.8bfc7aaa.jpg";